/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Unit of usage in Langfuse
 */
export type ModelUsageUnit =
  | "CHARACTERS"
  | "TOKENS"
  | "MILLISECONDS"
  | "SECONDS"
  | "IMAGES"
  | "REQUESTS";
export const ModelUsageUnit = {
  Characters: "CHARACTERS",
  Tokens: "TOKENS",
  Milliseconds: "MILLISECONDS",
  Seconds: "SECONDS",
  Images: "IMAGES",
  Requests: "REQUESTS",
} as const;
